import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { splayParams } from "../utils/splay-params";

@Injectable()
export class DiffStatsService {
  constructor(private http: HttpClient) {}

  public get(params: any) {
    let projectId;
    let prevRevision;
    let revision;

    [params, projectId, prevRevision, revision] = splayParams(
      params,
      "projectId",
      "prevRevision",
      "revision",
    );
    const url =
      `/api/v4/projects/${projectId}/diff-stats` +
      `?prev_revision=${prevRevision}&revision=${revision}`;

    return this.http.get(url, { params });
  }

  public list(params: any) {
    let projectId;
    let revisions;

    [params, projectId, revisions] = splayParams(
      params,
      "projectId",
      "revisions",
    );
    const url = `/api/v4/projects/${projectId}/diff-stats-list?revisions=${revisions}`;

    return this.http.get(url, { params });
  }
}
